<template>
<div class="container mt-16 text-center grey--text">
    {{$t(`${text}`)}}
</div>
</template>

<script>
export default {
props: ["text"]
}
</script>

<style>

</style>